<div class="flex flex-column gap-2" [formGroup]="form">
  <app-input-text [name]="keyField" [label]="keyLabel" [form]="form"></app-input-text>
  <app-input-text [name]="valueField" [label]="valueLabel" [form]="form"></app-input-text>
</div>
